import { ISanitySlug } from 'typescriptDefs';

const generateBlogPathname = ({
  locale,
  slug,
  subfolder,
}: {
  locale: string;
  slug: ISanitySlug;
  subfolder: string | undefined | null;
}): string => {
  return `/${locale === 'fr' ? 'fr/' : ''}${subfolder ?? 'learn'}/${slug.current}/`;
};

export default generateBlogPathname;
